import { useState } from 'react';
import { lovemoFaqs } from '@/mocks/lovemoContent';
import LovemoSectionHeading from '@/components/feature/LovemoSectionHeading';

export default function LovemoFaq() {
  const [openId, setOpenId] = useState<string | null>(lovemoFaqs[0]?.id ?? null);

  const toggle = (id: string) => {
    setOpenId((prev) => (prev === id ? null : id));
  };

  return (
    <section id="lovemo-faq" className="bg-background-100">
      <div className="mx-auto w-full max-w-[1280px] px-4 py-16 md:px-8 md:py-24">
        <LovemoSectionHeading
          eyebrow="常见问题"
          title="关于Lovemo，你可能想知道"
          desc="下载、安装、隐私、多端同步，这里解答你最关心的问题。"
        />

        <div className="mx-auto mt-12 max-w-3xl space-y-3">
          {lovemoFaqs.map((faq) => {
            const isOpen = openId === faq.id;
            return (
              <div
                key={faq.id}
                className="lovemo-reveal overflow-hidden rounded-lg border border-background-200/70 bg-background-50"
              >
                <button
                  type="button"
                  onClick={() => toggle(faq.id)}
                  aria-expanded={isOpen}
                  className="flex w-full cursor-pointer items-center justify-between gap-4 px-5 py-4 text-left"
                >
                  <span className="font-label text-sm font-semibold text-foreground-950 md:text-base">
                    {faq.question}
                  </span>
                  <span
                    className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full transition-colors ${
                      isOpen ? 'bg-primary-500 text-background-50 dark:text-background-950' : 'bg-background-200/70 text-foreground-700'
                    }`}
                  >
                    <i
                      className={`text-lg transition-transform duration-300 ${
                        isOpen ? 'ri-subtract-line' : 'ri-add-line'
                      }`}
                      aria-hidden="true"
                    />
                  </span>
                </button>
                <div
                  className={`grid transition-all duration-300 ease-out ${
                    isOpen ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'
                  }`}
                >
                  <div className="overflow-hidden">
                    <p className="px-5 pb-5 text-sm leading-relaxed text-foreground-700">{faq.answer}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}